
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';

import IfComp from '../../common/client/components/IfComp';
import Text from '../../common/client/components/Text';

import openFile from '../common/openFile';

// ToDo: move to common
const IMPORT_MODE_DEFINITION = 'IMPORT_DEFINITION';
const IMPORT_MODE_ALL = 'IMPORT_ALL';

const classNames = mergeStyleSets({
    ImportCategoryParcel: {

    },
    FileContentInfo: {

    },
    buttons: {
        paddingTop: 16
    },
    sectionTitle: {
        marginTop: 8,
        marginBottom: 8,
    },
    sectionContent: {
        marginLeft: 16,
        marginBottom: 16,
    },
    choiceRoot: {
        width: 400
    },
    innerContent: {
        paddingLeft: 26
    }
});

const ActualCategoryParcel = ({categoryParcelItems, disabled, onItemSelect}) => {

    const handleChangeItemSelect = (itemName, itemChecked) => {
        if (onItemSelect) {
            onItemSelect(itemName, itemChecked);
        }
    }

    return (
        <Stack className={classNames.FileContentInfo}>
            <Stack.Item className={classNames.sectionTitle}>
                <Text>Vyberte položky aktuální kategorie parcel, které chcete zachovat</Text>
            </Stack.Item>
            <Stack.Item className={classNames.sectionContent}>
                <Stack tokens={{childrenGap: 4}}>
                    {categoryParcelItems.map(item => {
                        return (
                            <Checkbox
                                key={item.item_name}
                                disabled={disabled}
                                label={item.item_title}
                                onChange={(event, isChecked) => {
                                    handleChangeItemSelect(
                                        item.item_name, isChecked
                                    );
                                }}
                            />
                        );
                    })}
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

const ChoiceActualCategoryParcel = ({categoryParcelItems, onItemSelect, originalProps, render}) => {
    return (
        <div className={classNames.choiceRoot}>
            {render(originalProps)}
            <div className={classNames.innerContent}>
                <IfComp cond={originalProps.checked}>
                    <ActualCategoryParcel
                        categoryParcelItems={categoryParcelItems}
                        disabled={!originalProps.checked}
                        onItemSelect={onItemSelect}
                    />
                </IfComp>
            </div>
        </div>
    );
}

const ImportMode = ({mode, categoryParcelItems, onItemSelect, onChange}) => {
    return (
        <ChoiceGroup
            selectedKey={mode}
            onChange={onChange}
            options={[
                {
                    key: IMPORT_MODE_DEFINITION,
                    text: 'Importovat jen definice položek kategorie parcel',
                },
                {
                    key: IMPORT_MODE_ALL,
                    text: 'Importovat vše (definice i zařazení parcel)',
                    onRenderField: (renderProps, render) => {
                        return (
                            <ChoiceActualCategoryParcel
                                originalProps={renderProps}
                                render={render}
                                categoryParcelItems={categoryParcelItems}
                                onItemSelect={onItemSelect}
                            />
                        );
                    }
                },
            ]}
        />
    );
}

const FileContentProperty = ({title, value}) => {
    return (
        <Stack horizontal tokens={{childrenGap: 8}}>
            <Text>{title}: </Text>
            <Text bold>{value}</Text>
        </Stack>
    );
}

const FileContentInfo = ({fileContent}) => {

    let parcCount = fileContent.parc.length;
    let items = [];

    fileContent.parc.forEach(item => {
        if (items.indexOf(item.item_name) === -1) {
            items.push(item.item_name);
        }
    });

    return (
        <Stack className={classNames.FileContentInfo}>
            <Stack.Item className={classNames.sectionTitle}>
                <Text >Načtený soubor obsahuje následující kategorii parcel</Text>
            </Stack.Item>
            <Stack.Item className={classNames.sectionContent}>
                <Stack>
                    <FileContentProperty
                        title="Projekt"
                        value={fileContent.info.project_title}
                    />
                    <FileContentProperty
                        title="Kategorie parcel"
                        value={fileContent.info.category_title}
                    />
                    <FileContentProperty
                        title="Počet položek kategorie parcel"
                        value={items.length}
                    />
                    <FileContentProperty
                        title="Počet parcel v kategorii"
                        value={parcCount}
                    />
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

const ImportCategoryParcel = ({categoryParcel, categoryParcelItems, onImport}) => {

    const [fileContent, setFileContent] = React.useState(null);
    const [error, setError] = React.useState(false);
    const [itemSelected, setItemSelected] = React.useState({});
    const [importMode, setImportMode] = React.useState(IMPORT_MODE_DEFINITION);

    const handleChangeImportMode = (event, option) => {
        setImportMode(option.key);
    }

    const handleImportClick = () => {
        if (onImport) {
            let items = [];
            for (let itemName in itemSelected) {
                if (itemSelected[itemName] && (importMode === IMPORT_MODE_ALL)) {
                    items.push(itemName);
                }
            }

            let parc = (importMode === IMPORT_MODE_ALL)
                ? fileContent.parc
                : [];

            onImport(fileContent.items, parc, items, importMode);
        }
    }

    const handleItemSelect = (name, selected) => {
        setItemSelected({
            ...itemSelected,
            [name]: selected
        });
    }

    const handleOpenFileClick = () => {
        openFile('application/json', handleProcessFile)
    }

    const handleProcessFile = (file) => {
        let reader = new FileReader();
        reader.onload = () => {
            let text = reader.result;
            try {
                let data = JSON.parse(text);
                if (data.type && data.type === 'PARCEL_ONLINE_CATEGORY_PARC') {
                    setFileContent(data);
                    setError(false);
                } else {
                    setFileContent(null);
                    setError(true);
                }
            }
            catch (e) {
                setError(true);
            }
        };
        reader.readAsText(file);
    }

    return (
        <Stack className={classNames.ImportCategoryParcel}>
            <IfComp cond={!fileContent}>
                <DefaultButton
                    text="Načíst soubor s kategorií parcel"
                    onClick={handleOpenFileClick}
                />
            </IfComp>
            <IfComp cond={fileContent}>
                <FileContentInfo
                    fileContent={fileContent}
                />
                <ImportMode
                    mode={importMode}
                    categoryParcelItems={categoryParcelItems}
                    onChange={handleChangeImportMode}
                    onItemSelect={handleItemSelect}
                />
                <Stack.Item className={classNames.buttons}>
                    <Stack horizontal>
                        <PrimaryButton
                            text="Importovat"
                            onClick={handleImportClick}
                        />
                    </Stack>
                </Stack.Item>
            </IfComp>
            <IfComp cond={error}>
                <Text color="#ff0000">Při načítání souboru došlo k chybě</Text>
            </IfComp>
        </Stack>
    );
}

export default ImportCategoryParcel;
